import { language as lan_bankTransferIntroSteps } from "./bank-transfer-intro-steps";
import { language as lan_websiteBankTransferInfo } from "./website-bank-transfer-info";

let language = {
    ...lan_bankTransferIntroSteps,
    ...lan_websiteBankTransferInfo,
    BANK_TRANSFER_INTRO_TITLE: "通过电汇/银行转账支付",
    BANK_TRANSFER_INTRO_DES1: "为完成您的支付，请简单遵循这两个简单的步骤，将订单总金额从您的银行转账至我们的账户。",
    BANK_TRANSFER_INTRO_ORDER_NO_TITLE: "{{website}}订单编号：",
    BANK_TRANSFER_INTRO_BANK_INFO_TITLE: "{{website}}银行信息：",
    BANK_TRANSFER_INTRO_CONTACT_US:"联系我们",
    BANK_TRANSFER_INTRO_DES2:"如果您有任何问题或需要帮助，请随时通过{{supportEmail}}联系我们。",
    BANK_TRANSFER_INTRO_DES3:"感谢您的订单！",

    /*************************** 参数校验 *************************/
    // 地址参数校验提示
    BANK_TRANSFER_INTRO_URL_INVALID_PARAM_TITLE: "无效的网址",
    // 地址参数缺失
    BANK_TRANSFER_INTRO_URL_PARAM_MISSING_CONTENT: "银行转账介绍网址无效。请返回上一页并重试。如果需要进一步帮助，请随时通过{{supportEmail}}联系我们的支持团队。",
    BANK_TRANSFER_INTRO_LOADING_TITLE: "页面加载问题",
    BANK_TRANSFER_INTRO_LOADING_CONTENT1: "在加载此页面时出现问题。请刷新页面并重试。如果问题仍然存在，请随时通过{{supportEmail}}联系我们的支持团队。",
    // 订单不存在
    BANK_TRANSFER_INTRO_PAGE_LOADING_CONTENT2: "订单未找到。请仔细检查URL，刷新页面重试。如果需要进一步帮助，请随时通过{{supportEmail}}联系我们的支持团队。",
};

export { language }